import { useState, useEffect } from 'react'
import { getTravelsAPI } from '../services/travel'

function UseEmpsTravels() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getTravelsAPI()
      if (!result) return

      const newData = result.result.map((d, i) => {
        return { value: d.id, label: d.travelling }
      })

      setData(newData)
    }
    getData()
  }, [])

  return data
}

export default UseEmpsTravels
